class GloweHeroCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-hero-track]');
    this.slides = [...this.querySelectorAll('[data-hero-slide]')];
    this.index = 0;
    this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
    this.interval = Number(this.dataset.interval) || 6000;
    this.autoplay = this.dataset.autoplay === 'true' && !this.reduceMotion.matches;
    this.pauseOnHover = this.dataset.pauseOnHover === 'true';
    if (this.slides.length < 2) return;
    this.buildDots();
    this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
    this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
    if (this.pauseOnHover) {
      this.addEventListener('pointerenter', () => this.stop());
      this.addEventListener('pointerleave', () => this.start());
    }
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());
    this.addEventListener('touchstart', (event) => { this.touchStart = event.touches[0].clientX; this.stop(); }, { passive: true });
    this.addEventListener('touchend', (event) => {
      const distance = event.changedTouches[0].clientX - this.touchStart;
      if (Math.abs(distance) > 45) this.go(this.index + (distance < 0 ? 1 : -1), true);
      else this.restart();
    }, { passive: true });
    document.addEventListener('visibilitychange', this.onVisibility);
    this.start();
  }

  disconnectedCallback() {
    this.stop();
    clearTimeout(this.restartTimer);
    document.removeEventListener('visibilitychange', this.onVisibility);
  }
  onVisibility = () => document.hidden ? this.stop() : this.start();

  buildDots() {
    const holder = this.querySelector('[data-hero-dots]');
    if (!holder) return;
    this.slides.forEach((_, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'glowe-hero-carousel__dot';
      button.setAttribute('aria-label', `Show hero slide ${index + 1}`);
      button.addEventListener('click', () => this.go(index, true));
      holder.append(button);
    });
    this.dots = [...holder.children];
    this.update();
  }

  go(next, manual = false) {
    this.index = (next + this.slides.length) % this.slides.length;
    this.update();
    if (manual) this.restart();
  }

  update() {
    if (this.dataset.transition !== 'fade') this.track.style.transform = `translate3d(-${this.index * 100}%,0,0)`;
    this.slides.forEach((slide, index) => {
      const inactive = index !== this.index;
      slide.setAttribute('aria-hidden', String(inactive));
      slide.toggleAttribute('inert', inactive);
      slide.toggleAttribute('data-active', !inactive);
    });
    this.dots?.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
  }

  start() {
    if (!this.autoplay || this.timer || document.hidden || this.reduceMotion.matches) return;
    this.timer = setInterval(() => this.go(this.index + 1), this.interval);
  }

  stop() { clearInterval(this.timer); this.timer = null; }

  restart() {
    this.stop();
    clearTimeout(this.restartTimer);
    this.restartTimer = setTimeout(() => this.start(), 700);
  }
}

if (!customElements.get('glowe-hero-carousel')) customElements.define('glowe-hero-carousel', GloweHeroCarousel);
